<template>
  <div class="auth-user" style="height: 420px">
    <v-scroll-x-transition hide-on-leave>
      <v-form ref="form" style="width: 100%" v-if="!resetForm" v-model="valid" lazy-validation>
        <v-alert v-if="environment.name == 'staging'" type="error" class="text-center">
          Você está no ambiente de <strong>HOMOLOGAÇÃO</strong>
        </v-alert>

        <v-text-field
          id="user-email"
          color="#1e1e1e"
          placeholder="Email"
          v-model="email"
          :rules="[rules.required, rules.email]"
          required
          @keyup.enter="sendUserCredentials(email, password)"></v-text-field>
        <v-text-field
          id="user-pass"
          color="#1e1e1e"
          :append-icon="setIcon(show)"
          :type="changeInputType(show)"
          @click:append="show = !show"
          @keyup.enter="sendUserCredentials(email, password)"
          :rules="[rules.required]"
          v-model="password"
          name="input-10-1"
          placeholder="Senha"></v-text-field>
        <v-btn
          depressed
          block
          large
          color="#1e1e1e"
          class="mt-3"
          style="color: #fff"
          id="send-credentials"
          @click="sendUserCredentials(email, password)"
          :disabled="loading"
          :loading="loading"
          >Entrar</v-btn
        >
        <div class="credential-options">
          <a id="forgot-password" @click="resetForm = !resetForm">Esqueci minha senha!</a>
        </div>
      </v-form>
    </v-scroll-x-transition>
    <v-scroll-x-reverse-transition hide-on-leave>
      <v-form ref="form" v-if="resetForm">
        <p class="font-weight-regular">Alterar senha</p>
        <v-text-field
          id="user-email"
          color="#1e1e1e"
          label="Email"
          v-model="email"
          :rules="[rules.required, rules.email]"
          required
          @keyup.enter="sendUserCredentials(email, password)"></v-text-field>
        <v-btn
          depressed
          block
          large
          dark
          color="#1e1e1e"
          class="mt-3"
          id="send-forgot-password-email"
          @click="resetPassword(email)"
          :disabled="loading"
          :loading="loading"
          >Enviar</v-btn
        >
        <v-btn
          outlined
          block
          large
          dark
          color="#1e1e1e"
          class="mt-3"
          @click="resetForm = !resetForm"
          >Voltar</v-btn
        >
      </v-form>
    </v-scroll-x-reverse-transition>

    <div id="recaptcha-container" class="my-4"></div>
  </div>
</template>
<script lang="ts">
declare global {
  interface Window {
    grecaptcha: any;
    onloadCallback: () => void;
  }
}

import { signin } from "@/services/auth";
import { removeAuthToken } from "@/utils/token";
import { Vue, Component } from "vue-property-decorator";
import { resetPassword } from "@/services/user";
import { Mutation } from "vuex-class";
import environment from "@/environment";

@Component
export default class UserAuth extends Vue {
  recaptchaWidgetId: number | null = null;

  $refs!: HTMLFormElement;
  setLoadingShow: any;
  environment = environment;
  show = false;
  resetForm = false;
  email = "";
  password = "";
  loading = false;
  valid = true;
  rules = {
    required: (value: string): unknown => !!value || "Campo é necessário",
    email: (value: string): unknown => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Email inválido";
    },
  };

  @Mutation("setAuthToken", { namespace: "loginState" })
  setAuthToken!: (token: string | null) => void;

  async resetPassword(email: string): Promise<void> {
    if (!this.$refs.form.validate()) return;
    try {
      await resetPassword(email);
      this.$emit("snackbar", {
        message: "E-mail foi enviado!",
      });
    } catch (err) {
      console.info(err);
      this.$emit("snackbar", {
        message: "Erro ao enviar reset de senha!",
      });
    }
  }

  cleanupCaptcha(): void {
    const container = document.getElementById("recaptcha-container");
    if (container) container.innerHTML = "";
  }

  renderRecaptcha(): void {
    if (this.recaptchaWidgetId !== null) {
      window.grecaptcha.enterprise.reset(this.recaptchaWidgetId);
      return;
    }

    const tryRender = () => {
      if (
        window.grecaptcha &&
        window.grecaptcha.enterprise &&
        typeof window.grecaptcha.enterprise.render === "function"
      ) {
        this.recaptchaWidgetId = window.grecaptcha.enterprise.render("recaptcha-container", {
          sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
          theme: "dark",
          size: "invisible",
        });
      } else {
        setTimeout(tryRender, 200);
      }
    };

    tryRender();
  }

  mounted(): void {
    this.loading = true;

    /*
     * Caso o usuário esteja logado e volte
     * o token é removido
     */
    removeAuthToken();
    this.setAuthToken(null);

    this.cleanupCaptcha();
    this.renderRecaptcha();

    this.loading = false;
  }

  onloadCallback() {
    if (window.grecaptcha && window.grecaptcha.enterprise) {
      this.recaptchaWidgetId = window.grecaptcha.enterprise.render("recaptcha-container", {
        sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        theme: "dark",
        size: "invisible",
      });
    } else {
      console.error("grecaptcha.enterprise não carregado");
    }
  }

  changeResetFormState(value: boolean): void {
    this.resetForm = value;
  }

  setIcon(show: boolean): string {
    return show ? "mdi-eye" : "mdi-eye-off";
  }

  changeInputType(show: boolean): string {
    return show ? "text" : "password";
  }

  isFormValid(): boolean {
    return this.email != "" && this.password != "";
  }

  sendToChangePassword(token: string): void {
    this.$router.push({
      name: "changepassword",
      query: { token: token },
    });
  }

  sendToValidate2FA(token: string, ask_for: string): void {
    this.setAuthToken(token);
    localStorage.setItem("2fa", ask_for);
  }

  sendToMyApps(token: string): void {
    this.setAuthToken(token);
    this.$router.push({
      name: "my-apps",
    });
  }

  handleSignInError(e: any): void {
    const errorCode = e.response?.data.errors[0].code;
    const errorStatus = e.response?.status;
    const tokenChangePassword = e.response?.data?.errors[0]?.token_change_password;

    if (!errorCode && !errorStatus) {
      this.$emit("snackbar", {
        message: "Ocorreu algum erro, tente novamente mais tarde",
      });
    }

    if (errorCode) {
      if (errorCode === 4018) {
        this.$emit("snackbar", {
          top: true,
          multiLine: true,
          color: "red",
          textStyle: "font-weight: 600;",
          transition: "scroll-y-transition",
          message:
            "Usuário desativado após muitas tentativas de login. Entre em contato com o suporte para reativar sua conta.",
        });
      }
      if (errorCode === 4019) {
        this.$emit("snackbar", {
          top: true,
          multiLine: true,
          color: "warning",
          timeout: 10000,
          textStyle: "font-weight: 600;",
          transition: "scroll-y-transition",
          message: e.response?.data.errors[0].description,
        });
      }
      if (errorCode === 4008) {
        this.$emit("snackbar", {
          top: true,
          multiLine: true,
          color: "red",
          textStyle: "font-weight: 600;",
          transition: "scroll-y-transition",
          message: e.response?.data.errors[0].description,
        });
      }
      if (errorCode === 4003) {
        this.$emit("snackbar", {
          top: true,
          multiLine: true,
          color: "red",
          textStyle: "font-weight: 600;",
          transition: "scroll-y-transition",
          message: "Usuário ou senha inválidos.",
        });
      }
      if (errorCode === 4016) {
        this.$router.push({
          name: "changepassword",
          query: { token: tokenChangePassword },
        });
      }
    }

    if (errorStatus) {
      if (errorStatus === 429) {
        this.$emit("snackbar", {
          message: "Muitas tentativas, aguarde alguns instantes.",
        });
      }
      if (errorStatus === 500) {
        this.$emit("snackbar", {
          message: "Erro ao tentar se conectar com o servidor.",
        });
      }
    }
  }

  async sendUserCredentials(email: string, password: string): Promise<void> {
    this.loading = true;
    try {
      if (this.$refs.form.validate()) {
        const grecaptcha = (window as any).grecaptcha;
        if (this.recaptchaWidgetId != null && grecaptcha?.enterprise) {
          // a cada tentativa de login, gera um tokden de captcha novo
          grecaptcha.enterprise.reset(this.recaptchaWidgetId);

          const recaptchaToken = await grecaptcha.enterprise.execute(this.recaptchaWidgetId);

          const loginResponse: any = await signin({
            email: email,
            password: password,
            recaptcha_token: recaptchaToken,
          });

          if (loginResponse && loginResponse.status == 200) {
            this.setAuthToken(loginResponse.data.token);

            if (!loginResponse.data.ask_for) {
              if (this.$route.query.continue) {
                const query: any = this.$route.query;
                this.$router.push({ path: decodeURIComponent(query.continue) });
              } else {
                this.$router.push({ name: "my-apps" });
              }
            }

            if (loginResponse.data.ask_for) {
              localStorage.setItem("2fa", loginResponse.data.ask_for);
              if (loginResponse.data.ask_for == "change_password") {
                this.sendToChangePassword(loginResponse.data.token);
              } else if (loginResponse.data.ask_for == "validate_2fa") {
                this.sendToValidate2FA(loginResponse.data.token, loginResponse.data.ask_for);
              } else if (loginResponse.data.ask_for == "register_2fa") {
                this.sendToValidate2FA(loginResponse.data.token, loginResponse.data.ask_for);
              } else {
                this.sendToMyApps(loginResponse.data.token);
              }
            }
          }
        }
      }
    } catch (e: any) {
      this.handleSignInError(e);
    } finally {
      this.loading = false;
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/utils/_variables.scss", "@/assets/styles/utils/_mixins.scss";

.user-error {
  height: 28px;
  .v-messages__message {
    position: relative;
    top: -20px;
    width: 100%;
    background-color: #ffdbdb;
    text-align: center;
    height: 28px;
    align-items: center;
    border-radius: 10px;
    font-weight: 800;
    font-size: 14px;
    padding: 1.2rem 1rem !important;
  }
}

.auth-user {
  margin-top: 40px;
  padding: 0 40px;
  @media (max-width: 960px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
  }
}

.mdi-chevron-left {
  color: $primaryBtnFontColor;
}

.credential-options {
  margin-top: 18px;
  a {
    color: $secondaryStrongFontColor;
    text-decoration: none;
    font-weight: 600;
    font-size: $mainContentFontSize;
  }
}
</style>
